import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";

class Valores extends Component {

    contenido = () => (
        <div id="valores">
            <Timeline>
                <Event interval="Valores">
                    <p className="fuente-monserrat" align="justify">
                        El IUDLM orienta la propuesta de enseñanza-aprendizaje a la formación de un profesional respetuoso y comprometido con el contexto nacional, regional e internacional. En ese sentido promueve los siguientes valores:
                    </p>
                    <div style={{padding:20}}>
                        <b>Excelencia:</b>
                        <p style={{fontSize:10}} className="fuente-monserrat" align="justify">
                            Privilegiando la calidad de los egresados y el carácter integral de su formación.
                        </p>
                        <b>Honestidad:</b>
                        <p style={{fontSize:10}} className="fuente-monserrat" align="justify">
                            Actuando bajo principios morales, éticos y legales que favorecen el cabal cumplimiento de las obligaciones y de los deberes individuales y colectivos.
                        </p>
                        <b>Compromiso:</b>
                        <p style={{fontSize:10}} className="fuente-monserrat" align="justify">
                            Formando parte activa en el desarrollo económico, social, cultural e intelectual del país.
                        </p>
                        <b>Conciencia Ecológica:</b>
                        <p style={{fontSize:10}} className="fuente-monserrat" align="justify">
                            Comprometidos con la protección del medio ambiente y de los recursos naturales, capaces de evaluar el impacto de sus decisiones a futuro en pro de la sostenibilidad y sustentabilidad.
                        </p>
                        <b>Innovación:</b>
                        <p style={{fontSize:10}} className="fuente-monserrat" align="justify">
                            Desarrollando procesos cognitivos, afectivos y sociales, que propicien la creación de productos y soluciones a las necesidades presentes y futuras de la comunidad de la sociedad, para estar en permanente búsqueda de la excelencia.
                        </p>
                        <b>Creatividad:</b>
                        <p style={{fontSize:10}} className="fuente-monserrat" align="justify">
                        Entendida como la capacidad humana para modificar la visión que tiene de su entorno a partir de la conexión con su yo, lo cual le permite generar nuevas formas de relacionarse, crear nuevos objetos, promover nuevas ideas y procesos, con la capacidad de llevarlos a la práctica.
                        </p>
                    </div>
                </Event>
            </Timeline>
        </div>
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default Valores;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/Valores.jsx